document.addEventListener("DOMContentLoaded", function () {
  const swiperContainers = document.querySelectorAll(".cards-carousel__swiper");
  swiperContainers.forEach(function (container) {
    const swiper = new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 12,
      speed: 500,
      navigation: {
        nextEl: container.querySelector(".cards-carousel__next"),
        prevEl: container.querySelector(".cards-carousel__prev")
      },
      pagination: {
        el: container.querySelector(".cards-carousel__pagination")
      },
      breakpoints: {
        640: {
          spaceBetween: 30
        }
      }
    });
  });

  // Logo Grid – Swiper only on mobile (< 768px)
  const logoGridContainers = document.querySelectorAll(".logo-grid__swiper");
  logoGridContainers.forEach(function (container) {
    let logoGridSwiper = null;
    const mobileQuery = window.matchMedia("(max-width: 767px)");
    function handleLogoGridSwiper(e) {
      if (e.matches && !logoGridSwiper) {
        logoGridSwiper = new Swiper(container, {
          slidesPerView: "auto",
          spaceBetween: 32,
          speed: 500,
          loop: true,
          centeredSlides: true,
          pagination: {
            el: container.querySelector(".logo-grid__pagination")
          },
          navigation: {
            nextEl: container.querySelector(".logo-grid__next"),
            prevEl: container.querySelector(".logo-grid__prev")
          }
        });
      } else if (!e.matches && logoGridSwiper) {
        logoGridSwiper.destroy(true, true);
        logoGridSwiper = null;
      }
    }
    handleLogoGridSwiper(mobileQuery);
    mobileQuery.addEventListener("change", handleLogoGridSwiper);
  });
  const testimonialsCarousels = document.querySelectorAll(".testimonials-carousel__content");
  testimonialsCarousels.forEach(function (container) {
    const swiper = new Swiper(container.querySelector(".swiper"), {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: container.querySelector(".testimonials-carousel__next"),
        prevEl: container.querySelector(".testimonials-carousel__prev")
      }
    });
  });
  const textCarouselImages = document.querySelectorAll(".text-carousel__images");
  textCarouselImages.forEach(function (container) {
    const swiper = new Swiper(container.querySelector(".swiper"), {
      effect: "fade",
      loop: true,
      pagination: {
        el: container.querySelector(".text-carousel__pagination")
      },
      navigation: {
        nextEl: container.querySelector(".text-carousel__next"),
        prevEl: container.querySelector(".text-carousel__prev")
      }
    });
  });
  const accordions = document.querySelectorAll(".map-accordion .accordion");
  accordions.forEach(accordion => {
    const button = accordion.querySelector(".accordion__button");
    const content = accordion.querySelector(".accordion__content");
    button.addEventListener("click", () => {
      const isOpen = content.style.maxHeight;
      accordions.forEach(acc => {
        acc.querySelector(".accordion__content").style.maxHeight = null;
        acc.querySelector(".accordion__button").classList.remove("active");
      });
      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 16 + "px";
        button.classList.add("active");
      }
    });
  });
  const galleryBlock = document.getElementsByClassName("gallery-images");
  if (galleryBlock.length) {
    Array.from(galleryBlock).forEach(function (block) {
      lightGallery(block, {
        selector: "a",
        plugins: []
        // Configurar para usar href en lugar de data-src
        // O agregar data-src a los elementos
      });
    });
  }
});